import { render, staticRenderFns } from "./ReportHistory.vue?vue&type=template&id=661ed8fc"
import script from "./ReportHistory.vue?vue&type=script&lang=js"
export * from "./ReportHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports